import sdl from '@jds/react-generated-sdl/JDSDatepickerCalendarHeader';
import type { JDSDatepickerCalendarHeaderProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: JDSDatepickerCalendarHeaderProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const { custom = '', ...rest } = props as any;
  return createComponent(
    json,
    rest,
    'JDSDatepickerCalendarHeader',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const DatepickerCalendarHeader = withLogic(
  Component
) as React.FC<JDSDatepickerCalendarHeaderProps> & { slotName?: string };

DatepickerCalendarHeader.displayName = 'DatepickerCalendarHeader';
DatepickerCalendarHeader.slotName = 'jds_datepicker_calendar_header';

export { DatepickerCalendarHeader, type JDSDatepickerCalendarHeaderProps };
